import type { FaireProductEntity } from "../../entity_types/product";

export const p_vsngwqbuaw: FaireProductEntity = {
  token: "p_vsngwqbuaw",
  type: "product",
  name: "Vitamin B12 Liquid Drops for Energy, Nervous System Health",
  brandToken: "b_u4qayfrgch",
  brandName: "Drop Supplements",
  imageUrl:
    "https://cdn.faire.com/fastly/a96128ca1cf430144e2b2a625e1d5e85e06e3d6943c0026d1b7cafb5cbf7616a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/107eb075aa6a2c25d59345095e7bd90210913e33f2a81ce6d0a39afac34efd5f.png",
    "https://cdn.faire.com/fastly/f6a1f5f1a60b3c7353a50475f67c2e5b1b050ec80a0e5418c5e5b1908555bef1.jpeg",
    "https://cdn.faire.com/fastly/ffe9ecc5f617a360d944bc2aaf48dbc5e8f1a3d3538511726989c73e532e54ca.jpeg",
    "https://cdn.faire.com/fastly/912de5822766189593f8449291c0ac00fc619e0f3ad8c6190000adcd1848e692.jpeg",
    "https://cdn.faire.com/fastly/5af5403bdfe1e44ebad393954797f0a6e9157897016e7742dc105edbd3854058.jpeg",
    "https://cdn.faire.com/fastly/37e92c0ca65757a1dec20026a59b137f19d7c11b6b037f5628d43bb49da5fea7.jpeg",
    "https://cdn.faire.com/fastly/311e566c8a85312d4c04d9b0b09a94639d3c7df2842f4ad8938706f4abcd8dad.jpeg",
    "https://cdn.faire.com/fastly/f2630ea59e7433811cf7ba8043995141e6a61e8f6ed2ba77b61e4d6b32ad8984.jpeg",
  ],
  priceDollars: 13.5,
  description:
    "Vitamin B12, also known as cobalamin, is a powerhouse nutrient essential for your overall well-being. It plays a vital role in red blood cell production, supports brain health, promotes a healthy nervous system, and helps convert food into the energy your body needs to thrive.\n\nOur vegan-friendly Vitamin B12 drops are formulated with methylcobalamin, the natural and most bioavailable form of B12, ensuring optimal absorption and effectiveness. Each daily dose delivers 2500 mcg of B12 in a naturally sweet fruit flavor.\n\nOur Vitamin B12 drops are free from sugar, salt, starch, wheat, gluten, yeast, milk, soy derivatives, and artificial preservatives.\n\nINGREDIENTS: Vitamin B12 (as Methylcobalamin), Water (Reverse Osmosis), Vegetable Glycerin, Tart Cherry Juice (From Whole Montmorency Cherries), Natural Flavor, Citrus Extract, Organic Stevia Leaf Extract (Rebaudioside A)\n\nTASTES LIKE: Sweet cherries\n\nPERFECT FOR: Adding a few drops under your tongue for a boost of energy, red blood cell production and nervous system support.",
  tags: [],
  msrpDollars: 26.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:54.798Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
